// Su nişanlı şəkil (tap.az üslubu) — hər şəklin üstünə "Fiscal POS" overlay qoyur.
// • Su nişanı həm ekranda görünür (screenshot-da qalır), həm də uzun-basma/sağ-klik
//   şəkilin özünə yox, overlay-ə düşdüyü üçün iOS "Şəkli saxla" təklif etmir → təmiz save çətinləşir.
// • <img> pointer-events:none — toxunuş overlay-ə gedir; tap container onClick-ə qabarır (böyütmə işləyir).
const block = (e) => { e.preventDefault(); return false; };

export default function WatermarkedImage({
    src,
    alt = '',
    onClick,
    imgClassName = 'h-full w-full object-cover',
    fontSize = 14,
    text = 'Fiscal POS',
}) {
    return (
        <div
            className={`relative h-full w-full overflow-hidden ${onClick ? 'cursor-zoom-in' : ''}`}
            onClick={onClick}
        >
            <img
                src={src}
                alt={alt}
                draggable={false}
                onContextMenu={block}
                onDragStart={block}
                className={imgClassName}
                style={{ pointerEvents: 'none', WebkitUserSelect: 'none', userSelect: 'none', WebkitTouchCallout: 'none' }}
            />
            {/* Su nişanı overlay — toxunuşu tutur (save bloku) + mərkəzdə yazı */}
            <div
                className="absolute inset-0 flex items-center justify-center"
                aria-hidden
                onContextMenu={block}
                style={{ WebkitTouchCallout: 'none', WebkitUserSelect: 'none', userSelect: 'none' }}
            >
                <span
                    style={{
                        whiteSpace: 'nowrap',
                        color: 'rgba(255,255,255,0.55)',
                        fontWeight: 800,
                        fontSize: `${fontSize}px`,
                        letterSpacing: '0.02em',
                    }}
                >
                    {text}
                </span>
            </div>
        </div>
    );
}
